export default interface IInvitee {
    firstName: string;
    lastName: string;
    emailAddress: string;
    duration: number;
}

export const createInvitee = (): IInvitee => ({
    firstName: "",
    lastName: "",
    emailAddress: "",
    duration: 30
});